import Prism from 'prismjs'
window.Prism = Prism

import 'prismjs/plugins/autoloader/prism-autoloader'
import 'prismjs/plugins/previewers/prism-previewers'
import 'prismjs/plugins/toolbar/prism-toolbar'
import 'prismjs/plugins/show-language/prism-show-language'